import { LoanApplicationNetworkService } from './LoanApplicationNetworkService';
import { Init } from './models';
import { buildServiceBaseUrls } from './serviceBaseUrls';
import { store } from '~/store/store';
import { setWorkflowState } from '~/store/reducers/purchase/purchase';

let loanApplicationNetworkService: LoanApplicationNetworkService | undefined = undefined;

export const loanApplicationNetworkServiceInit = ({
  baseUrl,
  headers,
  track,
  onAuthenticationRequired,
}: Omit<Init, 'baseUrls'> & { baseUrl?: string | null }) => {
  loanApplicationNetworkService = new LoanApplicationNetworkService({
    baseUrls: buildServiceBaseUrls(baseUrl, window.sunbitE2eEnvNamespace),
    headers,
    track,
    onAuthenticationRequired,
    onWorkflowState: (workflowState) => {
      store.dispatch(setWorkflowState(workflowState));
    },
  });
  return loanApplicationNetworkService;
};

export { loanApplicationNetworkService };
